export enum Role {
  SUPERVISOR = 'SUPERVISOR',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPERADMIN',
}
